var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5465 12.0005L9.47323 7.9275C9.3349 7.789 9.26406 7.61492 9.26073 7.40525C9.25756 7.19575 9.3284 7.0185 9.47323 6.8735C9.61823 6.72867 9.7939 6.65625 10.0002 6.65625C10.2066 6.65625 10.3822 6.72867 10.5272 6.8735L15.0215 11.3678C15.2021 11.5486 15.2925 11.7595 15.2925 12.0005C15.2925 12.2415 15.2021 12.4524 15.0215 12.6333L10.5272 17.1275C10.3887 17.2658 10.2146 17.3367 10.005 17.34C9.79548 17.3432 9.61823 17.2723 9.47323 17.1275C9.3284 16.9825 9.25598 16.8068 9.25598 16.6005C9.25598 16.3942 9.3284 16.2185 9.47323 16.0735L13.5465 12.0005Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.315117b65259e709f6401950bad16b74.svg";
export { ForwardRef as ReactComponent };